import { useContext, useEffect, useRef } from 'react';
import { FocusManagerContext } from '../components/focus-manager';
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function useRegisterItemWithFocusManager() {
  const {
    registerRef
  } = useContext(FocusManagerContext);
  const itemRef = useRef(null);
  useEffect(() => registerRef(itemRef), [registerRef]);
  return itemRef;
}
export default useRegisterItemWithFocusManager;